import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 73.9 112.4" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0 56.2L56.3 0l17.6 17.7-38.5 38.5 38.5 38.5-17.6 17.7z" /></svg>);